import type { FaireProductEntity } from "../../entity_types/product";

export const p_u8qmdcdnma: FaireProductEntity = {
  token: "p_u8qmdcdnma",
  type: "product",
  name: "Tallow Cream Blush Stick",
  brandToken: "b_7sxzf99szh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cd274ba54b2a92b18cc352934e4c72d66a2ea1e23192edc84f41835b90631c9c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c6d9610f4610ffbc7212af2697a596cfac8a10470ac7a603fa520459fa22a6d.png",
    "https://cdn.faire.com/fastly/3e975f4ea53eba11dc0c6726c35ec424060ef75a88dfb21ebb854eac32e5773b.png",
    "https://cdn.faire.com/fastly/72fb8b3cc971ed65768a5ed19294392d027702dc018b2d6543d26223a6486b3c.png",
    "https://cdn.faire.com/fastly/4f9e578d51bc6fcb153d48e01143f742312ee1e0b2854ad3a552b9e914dfdcb1.png",
    "https://cdn.faire.com/fastly/ae095d5fa437ac36b8469b389cc4c8ab9454670b17bd44eba2d98cfa17f0b814.png",
    "https://cdn.faire.com/fastly/5fdbdd2bdb3b6ddc41fa4797609c7ea5219e6d0a6f1cd73b9ec327b844a1dac6.png",
  ],
  priceDollars: 17,
  description:
    "Our Tallow Cream Blush Sticks are a modern take on traditional beauty; crafted with grass-fed beef tallow, prickly pear seed oil, and high-performance powders for a natural subtle finish that melts seamlessly into the skin.\n\nThis multi-use cream formula is designed to feel weightless, breathable, and effortlessly blendable, delivering healthy-looking color that enhances the skin rather than sitting on top of it. The finish is soft, blurred, and never greasy—perfect for everyday wear.\n\nGenerously sized at 0.5 oz / 15 g, each stick glides on smoothly and blends with ease using fingers, a brush, or slide directly on skin.\n\nThis product is made-to-order, please allow 3-4 additional days for manufacturing time. \n\n",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:37.753Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
